import { MapContainer, TileLayer } from "react-leaflet";

export function MapAreaSelectorEmptyState({
  t,
}: {
  t: (key: string) => string;
}) {
  return (
    <div
      style={{
        position: "relative",
        height: "256px",
        width: "100%",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <MapContainer
        center={[0, 0]}
        zoom={2}
        style={{
          height: "100%",
          width: "100%",
          filter: "grayscale(80%) brightness(0.7)",
          borderRadius: "8px",
        }}
        scrollWheelZoom={false}
        dragging={false}
        doubleClickZoom={false}
        zoomControl={false}
        touchZoom={false}
        boxZoom={false}
        keyboard={false}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; OpenStreetMap contributors"
        />
      </MapContainer>

      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          color: "white",
          textAlign: "center",
          padding: "20px",
        }}
      >
        <div
          style={{
            fontSize: "16px",
            fontWeight: "500",
            maxWidth: "300px",
          }}
        >
          {t("selectAreaAboveToVisualize")}
        </div>
      </div>
    </div>
  );
}
